import {reqWithToken} from './requestHelper';

//crud

export async function insert(insert) {
    return (await reqWithToken('api/chinese',{
        method: 'post',
        data: insert
    })).data;
}

export async function getstud() {

    return (await reqWithToken('api/chinese/studentdata')).data;
}

export async function get(id) {
    return (await reqWithToken(`api/chinese/${id}`,)).data;
}



export async function getAll() {
    return (await reqWithToken('api/chinese')).data;
}

export async function getstudentAll() {
    return (await reqWithToken('api/chinese/getstudentAll')).data;
}

export async function update(update) {
    return (await reqWithToken('api/chinese',{
        method: 'put',
        data: update
    })).data;
}

export async function remove(id) {
    return (await reqWithToken('api/chinese/',{
        method: 'delete',
        params: {id}
    })).data;
}

export async function getFormActionByInfo(update) {
    return (await reqWithToken('api/chinese/getFormActionByInfo',{
        method: 'put',
        data: update
    })).data;
}

